var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.85,
    cy: 16.5,
    r: 16.5,
    fill: "#F1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.183 17.333h5a.834.834 0 0 0 .833-.833V9.833A.833.833 0 0 0 15.183 9h-5a.833.833 0 0 0-.833.833V16.5a.833.833 0 0 0 .833.833zm-.833 5.834a.833.833 0 0 0 .833.833h5a.833.833 0 0 0 .833-.833v-3.334a.833.833 0 0 0-.833-.833h-5a.833.833 0 0 0-.833.833v3.334zm8.333 0a.833.833 0 0 0 .833.833h5a.833.833 0 0 0 .834-.833v-5.834a.833.833 0 0 0-.834-.833h-5a.833.833 0 0 0-.833.833v5.834zm.833-8.334h5A.833.833 0 0 0 24.35 14V9.833A.833.833 0 0 0 23.516 9h-5a.833.833 0 0 0-.833.833V14a.833.833 0 0 0 .833.833z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.f5ce4633e3c89bb835c5a7608a200ae7.svg";
export { ForwardRef as ReactComponent };